export default __webpack_public_path__ + "static/media/Ayurveda-Bg.5cae5e34.svg";